/**
 * COUNTRY TO PHONE CODE MAPPING
 * 
 * Maps ISO 3166-1 alpha-3 country codes to international dialing codes
 * Used for displaying phone numbers with correct country codes on affiliate landing pages
 * 
 * Format: { 'ISO3': '+XXX' }
 */

export const COUNTRY_PHONE_CODES: Record<string, string> = {
 // Africa
 'DZA': '+213', // Algeria
 'AGO': '+244', // Angola
 'BEN': '+229', // Benin
 'BWA': '+267', // Botswana
 'BFA': '+226', // Burkina Faso
 'BDI': '+257', // Burundi
 'CMR': '+237', // Cameroon
 'CPV': '+238', // Cape Verde
 'CAF': '+236', // Central African Republic
 'TCD': '+235', // Chad
 'COM': '+269', // Comoros
 'COG': '+242', // Congo
 'COD': '+243', // Congo (DRC)
 'CIV': '+225', // Côte d'Ivoire
 'DJI': '+253', // Djibouti
 'EGY': '+20', // Egypt
 'GNQ': '+240', // Equatorial Guinea
 'ERI': '+291', // Eritrea
 'SWZ': '+268', // Eswatini
 'ETH': '+251', // Ethiopia
 'GAB': '+241', // Gabon
 'GMB': '+220', // Gambia
 'GHA': '+233', // Ghana
 'GIN': '+224', // Guinea
 'GNB': '+245', // Guinea-Bissau
 'KEN': '+254', // Kenya
 'LSO': '+266', // Lesotho
 'LBR': '+231', // Liberia
 'LBY': '+218', // Libya
 'MDG': '+261', // Madagascar
 'MWI': '+265', // Malawi
 'MLI': '+223', // Mali
 'MRT': '+222', // Mauritania
 'MUS': '+230', // Mauritius
 'MAR': '+212', // Morocco
 'MOZ': '+258', // Mozambique
 'NAM': '+264', // Namibia
 'NER': '+227', // Niger
 'NGA': '+234', // Nigeria
 'RWA': '+250', // Rwanda
 'STP': '+239', // S?o Tom? and Pr?ncipe
 'SEN': '+221', // Senegal
 'SYC': '+248', // Seychelles
 'SLE': '+232', // Sierra Leone
 'SOM': '+252', // Somalia
 'ZAF': '+27', // South Africa
 'SSD': '+211', // South Sudan
 'SDN': '+249', // Sudan
 'TZA': '+255', // Tanzania
 'TGO': '+228', // Togo
 'TUN': '+216', // Tunisia
 'UGA': '+256', // Uganda
 'ZMB': '+260', // Zambia
 'ZWE': '+263', // Zimbabwe

 // Asia
 'AFG': '+93', // Afghanistan
 'ARM': '+374', // Armenia
 'AZE': '+994', // Azerbaijan
 'BHR': '+973', // Bahrain
 'BGD': '+880', // Bangladesh
 'BTN': '+975', // Bhutan
 'BRN': '+673', // Brunei
 'KHM': '+855', // Cambodia
 'CHN': '+86', // China
 'GEO': '+995', // Georgia
 'IND': '+91', // India
 'IDN': '+62', // Indonesia
 'IRN': '+98', // Iran
 'IRQ': '+964', // Iraq
 'ISR': '+972', // Israel
 'JPN': '+81', // Japan
 'JOR': '+962', // Jordan
 'KAZ': '+7', // Kazakhstan
 'KWT': '+965', // Kuwait
 'KGZ': '+996', // Kyrgyzstan
 'LAO': '+856', // Laos
 'LBN': '+961', // Lebanon
 'MYS': '+60', // Malaysia
 'MDV': '+960', // Maldives
 'MNG': '+976', // Mongolia
 'MMR': '+95', // Myanmar
 'NPL': '+977', // Nepal
 'PRK': '+850', // North Korea
 'OMN': '+968', // Oman
 'PAK': '+92', // Pakistan
 'PSE': '+970', // Palestine
 'PHL': '+63', // Philippines
 'QAT': '+974', // Qatar
 'SAU': '+966', // Saudi Arabia
 'SGP': '+65', // Singapore
 'KOR': '+82', // South Korea
 'LKA': '+94', // Sri Lanka
 'SYR': '+963', // Syria
 'TWN': '+886', // Taiwan
 'TJK': '+992', // Tajikistan
 'THA': '+66', // Thailand
 'TLS': '+670', // Timor-Leste
 'TUR': '+90', // Turkey
 'TKM': '+993', // Turkmenistan
 'ARE': '+971', // United Arab Emirates
 'UZB': '+998', // Uzbekistan
 'VNM': '+84', // Vietnam
 'YEM': '+967', // Yemen

 // Europe
 'ALB': '+355', // Albania
 'AND': '+376', // Andorra
 'AUT': '+43', // Austria
 'BLR': '+375', // Belarus
 'BEL': '+32', // Belgium
 'BIH': '+387', // Bosnia and Herzegovina
 'BGR': '+359', // Bulgaria
 'HRV': '+385', // Croatia
 'CYP': '+357', // Cyprus
 'CZE': '+420', // Czech Republic
 'DNK': '+45', // Denmark
 'EST': '+372', // Estonia
 'FIN': '+358', // Finland
 'FRA': '+33', // France
 'DEU': '+49', // Germany
 'GRC': '+30', // Greece
 'HUN': '+36', // Hungary
 'ISL': '+354', // Iceland
 'IRL': '+353', // Ireland
 'ITA': '+39', // Italy
 'XKX': '+383', // Kosovo
 'LVA': '+371', // Latvia
 'LIE': '+423', // Liechtenstein
 'LTU': '+370', // Lithuania
 'LUX': '+352', // Luxembourg
 'MLT': '+356', // Malta
 'MDA': '+373', // Moldova
 'MCO': '+377', // Monaco
 'MNE': '+382', // Montenegro
 'NLD': '+31', // Netherlands
 'MKD': '+389', // North Macedonia
 'NOR': '+47', // Norway
 'POL': '+48', // Poland
 'PRT': '+351', // Portugal
 'ROU': '+40', // Romania
 'RUS': '+7', // Russia
 'SMR': '+378', // San Marino
 'SRB': '+381', // Serbia
 'SVK': '+421', // Slovakia
 'SVN': '+386', // Slovenia
 'ESP': '+34', // Spain
 'SWE': '+46', // Sweden
 'CHE': '+41', // Switzerland
 'UKR': '+380', // Ukraine
 'GBR': '+44', // United Kingdom
 'VAT': '+379', // Vatican City

 // North America
 'ATG': '+1', // Antigua and Barbuda
 'BHS': '+1', // Bahamas
 'BRB': '+1', // Barbados
 'BLZ': '+501', // Belize
 'CAN': '+1', // Canada
 'CRI': '+506', // Costa Rica
 'CUB': '+53', // Cuba
 'DMA': '+1', // Dominica
 'DOM': '+1', // Dominican Republic
 'SLV': '+503', // El Salvador
 'GRD': '+1', // Grenada
 'GTM': '+502', // Guatemala
 'HTI': '+509', // Haiti
 'HND': '+504', // Honduras
 'JAM': '+1', // Jamaica
 'MEX': '+52', // Mexico
 'NIC': '+505', // Nicaragua
 'PAN': '+507', // Panama
 'KNA': '+1', // Saint Kitts and Nevis
 'LCA': '+1', // Saint Lucia
 'VCT': '+1', // Saint Vincent and the Grenadines
 'TTO': '+1', // Trinidad and Tobago
 'USA': '+1', // United States

 // South America
 'ARG': '+54', // Argentina
 'BOL': '+591', // Bolivia
 'BRA': '+55', // Brazil
 'CHL': '+56', // Chile
 'COL': '+57', // Colombia
 'ECU': '+593', // Ecuador
 'GUY': '+592', // Guyana
 'PRY': '+595', // Paraguay
 'PER': '+51', // Peru
 'SUR': '+597', // Suriname
 'URY': '+598', // Uruguay
 'VEN': '+58', // Venezuela

 // Oceania
 'AUS': '+61', // Australia
 'FJI': '+679', // Fiji
 'KIR': '+686', // Kiribati
 'MHL': '+692', // Marshall Islands
 'FSM': '+691', // Micronesia
 'NRU': '+674', // Nauru
 'NZL': '+64', // New Zealand
 'PLW': '+680', // Palau
 'PNG': '+675', // Papua New Guinea
 'WSM': '+685', // Samoa
 'SLB': '+677', // Solomon Islands
 'TON': '+676', // Tonga
 'TUV': '+688', // Tuvalu
 'VUT': '+678', // Vanuatu
};

/**
 * Get phone code for a country
 * @param countryCode ISO 3166-1 alpha-3 country code
 * @returns International dialing code (e.g., '+27') or '+27' as default
 */
export const getPhoneCodeForCountry = (countryCode: string | null | undefined): string => {
 if (!countryCode) return '+27'; // Default to South Africa
 
 const code = COUNTRY_PHONE_CODES[countryCode.toUpperCase()];
 return code || '+27'; // Fallback to South Africa if country not found
};

/**
 * Format phone number with country code
 * @param phone Phone number (can start with 0, country code, or be plain number)
 * @param countryCode ISO 3166-1 alpha-3 country code
 * @returns Formatted phone number with country code
 */
export const formatPhoneWithCountryCode = (
 phone: string | null | undefined,
 countryCode: string | null | undefined
): string => {
 if (!phone) return '';
 
 const phoneCode = getPhoneCodeForCountry(countryCode);
 const cleanPhone = phone.replace(/[^0-9]/g, ''); // Remove all non-numeric characters
 
 // If phone already starts with the country code (without +), return with +
 if (cleanPhone.startsWith(phoneCode.substring(1))) {
 return `+${cleanPhone}`;
 }
 
 // If phone starts with 0, remove it and add country code
 if (cleanPhone.startsWith('0')) {
 return `${phoneCode}${cleanPhone.substring(1)}`;
 }
 
 // Otherwise, assume it's a local number and add country code
 return `${phoneCode}${cleanPhone}`;
};

